<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
      <template v-slot:top>
          <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="primary"
              class="mb-2 rounded-pill elevation-0"
              :style="{ 'margin-right': '10px' }"
              @click="dialog = true"
            >
              Add Data
            </v-btn>
            <v-btn
              icon
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-refresh</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </template>
        </v-toolbar>
      </template>
      <template slot="action" slot-scope="{ item }">
        <div
          class="d-flex justify-center align-center"
          style="height: 100%; width: 100%; min-height: 56px;"
        >
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </div>
      </template>
    </TableView>

    <setting-spe-fee
      :dialogFee="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      v-on:closeCancelParent="close"
    />
  </v-card>
</template>

<script>
import feeSpeMixin from '../../components/setting-fee/fee-spe/feeSpeMixin';


export default {
  mixins: [ feeSpeMixin ],
  components: {
    settingSpeFee: () => import('../../components/form/SettingSpeFee.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },

};
</script>